import { h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { useCallback } from 'preact/hooks';
import Translate from '../translate/translate';

const GeneralErrorMessage = () => {
	const refreshPage = useCallback(() => {
		// @ts-ignore
		window.location.reload(false);
	}, []);

	return (
		<div className="general-error-message" data-testid="general-error-message">
			<div className="general-error-details">
				<FontAwesomeIcon className="general-error-icon" icon={faExclamationCircle} />
				<div className="general-error-title">
					<Translate text="OOPS" />
				</div>
				<div className="general-error-description">
					<Translate text="SOMETHING_WENT_WRONG" />
				</div>
			</div>

			<div className="general-error-refresh-container">
				<button className="general-error-refresh-button" onClick={refreshPage}>
					<Translate text="REFRESH" />
				</button>
			</div>
		</div>
	);
};

export default GeneralErrorMessage;
